import React from 'react';
import { Link } from 'react-router-dom';
import { GlobalData } from '../../../types'
import styles from './Step2.module.scss';
import { Layout } from '../../../components/common/Layout/Layout';
import { StepHeader } from '../../../components/common/StepHeader/StepHeader';
import { Campaign } from '../../../components/common/Campaign/Campaign';
import { ChangeButtonLayout } from '../../../components/common/ChangeButtonLayout/ChangeButtonLayout';
import { redirectTo404 } from '../../../utils/redirectTo404';
import IconRightArrow  from '../../../assets/img/common/icon_right_arrow.svg';
import noImage  from '../../../assets/img/common/img_noimage.jpg';

interface Step2Props {
  data: GlobalData[];
  firstCollectionHandle: string | null;
  campaignTitle?: string;
  campaignSubtitle?: string;
}

export const Step2: React.FC<Step2Props> = ({ data, firstCollectionHandle, campaignTitle, campaignSubtitle }) => {
  if (!firstCollectionHandle) {
    redirectTo404();
    return null;
  }

  const collectionData = data.find(d => d.first_collection.handle === firstCollectionHandle);

  if (!collectionData) {
    redirectTo404();
    return null;
  }

  // first_otherのデータはオプショナル
  const collectionOtherData = data.find(d => d.first_collection.handle === "first_other");
  const collectionSecondOtherData = collectionOtherData?.second_collections?.[0]?.second_collection;

  const excludedHandles = [
    "メンズ-シューズ",
    "レディース-シューズ",
    "メンズ-スニーカー",
    "レディース-スニーカー",
    "バッグ-リュック-財布",
    "ベルトや革小物など",
    "スーツケース",
    "かさ-折りたたみ傘"
  ];

  return (
    <div className={styles.step2}>
      <Layout>
        <Campaign title={campaignTitle} subtitle={campaignSubtitle} />
        <ChangeButtonLayout stepNumber={1} firstCollectionTitle={collectionData.first_collection.title} />
        <StepHeader
          stepNumber={2}
          title="修理したい部分を選択してください"
        />
        <div className={styles.flex}>
          {collectionData.second_collections.map((secondCollectionData, secondCollectionIndex) => {
            const gaId = secondCollectionData.second_collection_metafields.metafields._ga_id;
            
            // 現在のURLパラメータを取得
            const currentParams = new URLSearchParams(window.location.search);
            currentParams.set('step', '3');
            currentParams.set('firstcollectionhandle', collectionData.first_collection.handle);
            currentParams.set('secondcollectionhandle', secondCollectionData.second_collection.handle);
            const linkPath = `/?${currentParams.toString()}`;
            
            return (
              <div key={secondCollectionIndex}>
                <Link
                  to={linkPath}
                  className={`${styles.itemFlex} ${gaId ? "js-trackEvent" : ""}`}
                  data-ga-id={gaId}
                >
                  <img
                    src={secondCollectionData.second_collection.image?.src || noImage}
                    alt={secondCollectionData.second_collection.image?.alt || secondCollectionData.second_collection.title}
                    width={100}
                    height={100}
                  />
                  <p className={styles.itemName}>{secondCollectionData.second_collection.title}</p>
                  <IconRightArrow />
                </Link>
              </div>
            );
          })}
          <div>
            {!excludedHandles.includes(firstCollectionHandle) && (() => {
              // 現在のURLパラメータを取得
              const currentParams = new URLSearchParams(window.location.search);
              currentParams.set('step', '4');
              currentParams.set('firstcollectionhandle', firstCollectionHandle);
              currentParams.set('secondcollectionhandle', collectionSecondOtherData?.handle || 'second_other');
              currentParams.set('producthandle', 'product_other');
              const linkPath = `/?${currentParams.toString()}`;
              
              return (
                <Link
                  to={linkPath}
                  className={`${styles.itemFlex} ${`Clk_Btn_AppPage2_${firstCollectionHandle}_others` ? "js-trackEvent" : ""}`}
                  data-ga-id={`Clk_Btn_AppPage2_${firstCollectionHandle}_others`}
                >
                  <img
                    src={collectionSecondOtherData?.image?.src || noImage}
                    alt={collectionSecondOtherData?.image?.alt || collectionSecondOtherData?.title || 'その他'}
                    width={100}
                    height={100}
                  />
                  <p className={styles.itemName}>{collectionSecondOtherData?.title || 'その他'}</p>
                  <IconRightArrow />
                </Link>
              );
            })()}
          </div>
        </div>
      </Layout>
    </div>
  );
};
